import { CHANNELS_CONFIG } from "./channels_config"; // fixed: was "./channels.config"
import { ANALOG_CHANNELS } from "./analog";
import { CABLE_CHANNELS } from "./cable";
import { DIGITAL_CHANNELS } from "./digital";
import { NOSTALGIA_CHANNELS } from "./nostalgia";
import { REALITY_CHANNELS } from "./reality";
import { FILMMAKER_CHANNELS } from "./filmmaker";
import { PLUTO_CHANNELS } from "./pluto";
import { TUBI_CHANNELS } from "./tubi";

console.log("CONFIG CHANNEL COUNT:", CHANNELS_CONFIG.length);

export const CONFIG_BY_NUMBER = Object.fromEntries(
  CHANNELS_CONFIG.map((ch) => [String(ch.number), ch])
);

export const TIME_SLOTS = [
  "8:00 PM",
  "8:30 PM",
  "9:00 PM",
  "9:30 PM",
  "10:00 PM",
  "10:30 PM",
  "11:00 PM",
  "11:30 PM",
  "12:00 AM",
  "12:30 AM",
  "1:00 AM",
  "1:30 AM",
  "2:00 AM",
];

export const CHANNEL_COL_WIDTH = 160;
export const SLOT_WIDTH = 210;

export const CHANNELS = [
  ...ANALOG_CHANNELS,
  ...CABLE_CHANNELS,
  ...DIGITAL_CHANNELS,
  ...NOSTALGIA_CHANNELS,
  ...REALITY_CHANNELS,
  ...FILMMAKER_CHANNELS,
  ...PLUTO_CHANNELS,
  ...TUBI_CHANNELS,
];

export function getInitialSelection() {
  const channel = CHANNELS[0];
  return {
    channelNumber: channel.number,
    title: channel.programs[0].title,
  };
}
